/** Canais públicos de contato e redes sociais (site institucional). */
export const CONTACT_EMAIL = 'contato@ufokko.com.br';

export const INSTAGRAM_HANDLE = 'ufokko.br';
export const INSTAGRAM_URL = 'https://www.instagram.com/ufokko.br/';
